module.exports = __webpack_public_path__ + "static/img/color3-2.5d8507a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/color3-2.jpg
// module id = DG0X
// module chunks = 1